import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-retort-vertical',
  standalone: false,
  templateUrl: './retort-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class RetortVerticalComponent {
  @Input() retortTest:any
}